import Vue from 'vue';


export default {
  setReportRoute(state: any, data: any) {
    state.report.route = data;
    Vue.set(state.report, 'route', data);
  },

  showFilters(state: any, payload: boolean) {
    state.report.showFilters = payload;
  },
  showSearch(state: any, payload: boolean) {
    state.report.showSearch = payload;
  },
  setActivePreset(state: any, payload: string) {
    state.report.activePreset = payload;
    window.localStorage.setItem('activePreset', payload);
  },
  setPresetsInfo(state: any, payload: string) {
    state.report.presets = payload;
  },
}
